// import components
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress
} from '@mui/material';
import Grid from '@mui/material/Grid';

// import external libraries
import { useTranslation } from 'react-i18next';

// import types
import { Patient } from '../types';

// import utils
import { formatDate } from 'utils/date';

interface PatientInfoProps {
  patient: Patient;
  isLoading?: boolean;
}

const PatientInfo = ({ patient, isLoading }: PatientInfoProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'careReceiversHome' });

  const displayName =
    patient.displayName ||
    [patient.lastName, patient.firstName].filter(Boolean).join(', ') ||
    '-';

  return (
    <Box p={3}>
      <Card>
        <CardContent>
          {isLoading ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid size={{ compact: 12, medium: 6 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {t('fields.clientNumber')}
                </Typography>
                <Typography variant="body1">
                  {patient.clientNumber || '-'}
                </Typography>
              </Grid>
              <Grid size={{ compact: 12, medium: 6 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {t('fields.displayName')}
                </Typography>
                <Typography variant="body1">{displayName}</Typography>
              </Grid>
              <Grid size={{ compact: 12, medium: 6 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {t('fields.dateOfBirth')}
                </Typography>
                <Typography variant="body1">
                  {formatDate(patient.dateOfBirth)}
                </Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PatientInfo;
